import { ActionRegistryCategory } from '../../ActionRegistryCategory';
import { ActionRegistryItem } from '../../ActionRegistryItem';
export class ActionsTopic extends ActionRegistryCategory {
    label = 'Topic';
    constructor(parent) {
        super(parent);
        super.init();
    }
    startNewCycle = () => new ActionRegistryItem({
        action: ({ app }) => app.directive.directiveStartNewCycle.startNewCycleByReload()
    });
}
